(function () {
  const mobileQuery = window.matchMedia('(max-width: 749px)');
  let observer;

  function observeTargets(root) {
    if (!mobileQuery.matches || !('IntersectionObserver' in window)) {
      return;
    }

    if (!observer) {
      observer = new IntersectionObserver(
        (entries) => {
          entries.forEach((entry) => {
            entry.target.classList.toggle('is-in-view', entry.isIntersecting);
          });
        },
        {
          threshold: 0.2,
          rootMargin: '0px 0px -10% 0px',
        }
      );
    }

    root.querySelectorAll('.animate-on-scroll').forEach((target) => observer.observe(target));
  }

  function syncMobileAnimations() {
    if (!mobileQuery.matches) {
      observer?.disconnect();
      document.querySelectorAll('.animate-on-scroll').forEach((target) => {
        target.classList.remove('is-in-view');
      });
      return;
    }

    observeTargets(document);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', syncMobileAnimations, { once: true });
  } else {
    syncMobileAnimations();
  }

  mobileQuery.addEventListener('change', syncMobileAnimations);
  document.addEventListener('shopify:section:load', (event) => observeTargets(event.target));
})();
